export var MOVES_HISTORY_SIZE = 5;
export var GRID_SIZE = 9;
var showPopupTimeout = 1000;
export var getPopupTimeout = function () { return showPopupTimeout; };
export var setPopupTimeout = function (t) { return (showPopupTimeout = t); };
